import { SkipForward } from '@carbon/icons-react';
import { createThemedStyles } from '@repo/theme/styles';
import { HorizBox, Pad } from 'component/basics';
import { CTAButton, TextButton } from 'component/button';
import { VideoVotingCountdownElement } from 'open-modules/zdf/component/countdown';
import { View } from 'react-native';
import { t } from 'util/stdtypes';

type VideoVotingCountdownViewProps = {
    children: React.ReactNode;
    onSkip?: () => void;
    onTimeUp?: () => void;
    onClickDiscourse?: () => void;
    timer?: number;
};

export function VideoVotingCountdownOverlay({ children, onSkip, onTimeUp, onClickDiscourse, timer = 1000 }: VideoVotingCountdownViewProps) {
    const s = useVideoVotingCountdownViewStyle();

    return (
        <View>
            {onTimeUp && timer && (
                <View style={s.countdown}>
                    <VideoVotingCountdownElement callback={onTimeUp} circleRadius={18} size={48} strokeWidth={4} timer={timer} />
                </View>
            )}
            <View style={s.container}>
                <View style={s.inner}>
                    {children}
                    <Pad size={24} />
                    <HorizBox center spread>
                        <CTAButton label={t('video_voting.discourse', 'Discourse')} onPress={onClickDiscourse} size='small' />
                        {onSkip && (
                            <TextButton
                                label={t('video_voting.continue_button', 'Continue')}
                                leftIcon={SkipForward}
                                onPress={onSkip}
                                type='small'
                            />
                        )}
                    </HorizBox>
                </View>
            </View>
        </View>
    );
}

const useVideoVotingCountdownViewStyle = createThemedStyles((tokens) => ({
    countdown: {
        position: 'absolute',
        right: 0,
        zIndex: 10,
    },
    container: {
        flex: 1,
        paddingRight: 16,
        paddingTop: 16,
    },
    inner: {
        flex: 1,
        backgroundColor: tokens.colors.colorSurfacePrimary,
        borderRadius: 6,
        padding: 20,
    },
}));
